import VideoSvg from 'src/assets/trip-video.raw.svg';
import DisconnectedSvgMarker from './svg/DisconnectedSvgMarker';
import ExternalAddressSvgMarker from './svg/ExternalAddressSvgMarker';
import IdleSvgMarker from './svg/IdleSvgMarker';
import MovingSvgMarker from './svg/MovingSvgMarker';
import NoDeviceSvgMarker from './svg/NoDeviceSvgMarker';
import NoGpsSvgMarker from './svg/NoGpsSvgMarker';
import ObsoleteSvgMarker from './svg/ObsoleteSvgMarker';
import OfflineSvgMarker from './svg/OfflineSvgMarker';
import PoweredDownSvgMarker from './svg/PoweredDownSvgMarker';
// import StaleCommsSvgMarker from './svg/StaleCommsSvgMarker';
import StaleSvgMarker from './svg/StaleSvgMarker';
import StoppedSvgMarker from './svg/StoppedSvgMarker';
import WarningSvgMarker from './svg/WarningSvgMarker';

export const markersByStatus = {
  idle: new IdleSvgMarker(),
  moving: new MovingSvgMarker(),
  noDevice: new NoDeviceSvgMarker(),
  stale: new StaleSvgMarker(),
  stopped: new StoppedSvgMarker(),
  warning: new WarningSvgMarker(),
  disconnected: new DisconnectedSvgMarker(),
  noGps: new NoGpsSvgMarker(),
  obsolete: new ObsoleteSvgMarker(),
  offline: new OfflineSvgMarker(),
  poweredDown: new PoweredDownSvgMarker(),
};

export const externalAddressMarker = new ExternalAddressSvgMarker();

export function addVideoIconToTripSvg(svg) {
  const regex = /([\s\n]*<\/g>[\s\n]*<\/svg>)$/;
  return svg.replace(regex, `${VideoSvg}$1`);
}
